module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Invoice":"Rechnung","Dismiss":"Schließen","Print":"Drucken","An error occurred!":"Ein Fehler ist aufgetreten!","Preview could not be rendered":"Vorschau konnte nicht generiert werden","Missing PDF":"PDF konnte nicht gefunden werden"}}')
  delete Component.options._Ctor
}
